import {NavbarTopAdmin, NavbarBottomAdmin} from './components'
import AuthProvider from '../Authentication/authProvider'
import axios from "axios"
import { useState, useEffect, useRef } from "react"
import ReactQuill from 'react-quill-new'

function EditNewsletter() {
    const [letters, setLetters] = useState([])
    const [letter, setLetter] = useState()
    const [formData, setFormData] = useState({})

    const bannerEdit = useRef()

    async function getNews() {
        const res = await axios.get('/getNewsletter')
        setLetters(res.data)
    }
    function editNews(e) {
        const rt = letters.filter(x => x.id === e)
        setLetter(rt[0])
        bannerEdit.current.style.display = 'block'
    }
    function handleDescrizione(e) {
        setFormData({ ...formData, testo1: e })
    }
    function handleDescrizione2(e) {
        setFormData({ ...formData, testo2: e })
    }
    function handleFooter(e) {
        setFormData({ ...formData, footer: e })
    }
    function handleInputChange(e) {
        const { name, value, type, checked } = e.target
        const inputValue = type === "checkbox" ? checked : value
        setFormData({ ...formData, [name]: inputValue })
    }
    function handleSubmit(e) {
        e.preventDefault()
    }

    useEffect(() => { getNews() }, [])
    useEffect(() => { console.log(letter) }, [letter])

    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <div style={{
            border: '2px solid lightskyblue', width: '95%', margin: '15em auto', overflowX: 'scroll', overflowY: 'hidden', paddingBottom: '20px'
        }}>
            <div style={{ display: 'grid', gridTemplateColumns: '6% 60% 20% 7%', padding: '5px', fontWeight: '700' }}>
                <div>ID</div>
                <div>TITOLO</div>
                <div>DATA</div>
            </div>
            {letters && letters
                .map(letter => (
                    <div key={letter.id}>
                        <div style={{ display: 'grid', gridTemplateColumns: '6% 60% 20% 7%', padding: '0 5px', fontSize: 'small' }}>
                            <div>{letter.id}</div>
                            <div>{letter.titolo.substring(0, 50)}...</div>
                            <div>{letter.created_at}</div>
                            <div><button onClick={() => { editNews(letter.id) }}>edit</button></div>
                        </div><hr />
                    </div>
                ))}

        </div>

        <div ref={bannerEdit} style={{
            display: 'none', position: 'fixed', top: '4em', left: '0', padding: '20px 20px 10em 20px', backgroundColor: 'whitesmoke', width: '100%',
            height: '100vh', overflowY: 'auto'
        }}>
            <img src={require('../userNotAuth/image/icons8-chiudi-macos-32.png')} alt='' style={{ cursor: 'pointer', float: 'right' }}
                onClick={() => { bannerEdit.current.style.display = 'none' }} />
            {letter &&
                <form onSubmit={handleSubmit} className='mt-1'>
                    <h3>Aggiungi card in Food&Travel</h3>
                    <div className='p-3'>
                        <label>CardTitle</label>
                        <input className="form-control" defaultValue={letter.cardtitle} name='cardTitle' maxLength={200} required onChange={handleInputChange} type='text' />

                        <label className='mt-2'>cardText</label>
                        <input className="form-control" name='cardText' defaultValue={letter.cardtext} maxLength={300} required onChange={handleInputChange} type='text' />
                    </div> <hr />

                    <h3 className='mt-5'>NewsletterDetails</h3>
                    <div className='p-3'>
                        <label className='mt-1'>Titolo</label>
                        <input className="form-control" name='title' defaultValue={letter.titolo} maxLength={300} required onChange={handleInputChange} type='text' />
                        <label className='mt-2'>sottotitolo</label>
                        <input className="form-control" name='sottotitolo' defaultValue={letter.sottotitolo} maxLength={300} required onChange={handleInputChange} type='text' />
                        <label className='mt-2'>fotoBottom</label>
                        <input className="form-control" name='fotoBottom' defaultValue={letter.fotobottom} maxLength={200} required onChange={handleInputChange} type='text' />
                    </div>

                    <h5 className='mt-1'><b>Corpo</b></h5>
                    <div className='p-3'>
                        <ReactQuill className="textarea-quill mt-1"/*ql-container è la classe in App.css */
                            theme="snow"
                            value={letter.testo1}
                            onChange={handleDescrizione}
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                    ['link'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                                ]
                            }}
                        />
                        <p className='text-danger'><i>{letter.testo1.length} *** max 5000</i></p>
                        <ReactQuill className="textarea-quill mt-3"/*ql-container è la classe in App.css */
                            theme="snow"
                            onChange={handleDescrizione2}
                             value={letter.testo2}
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                    ['link'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                                ]
                            }}
                        />
                        <p className='text-danger'><i>{letter.testo2.length} *** max 5000</i></p>
                    </div>

                    <h5 className='mt-1'><b>Footer</b></h5>
                    <div className='p-3'>
                        <ReactQuill className="textarea-quill mt-3"/*ql-container è la classe in App.css */
                            theme="snow"
                            onChange={handleFooter}
                            placeholder="Titolo e testo"
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                    ['link'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                                ]
                            }}
                        />
                        <p className='text-danger'><i>{letter.footer.length} *** max 3000</i></p>

                        <label className='mt-1'>Nome intestatario</label>
                        <input className="form-control" name='nome' required maxLength={20} onChange={handleInputChange} type='text' />

                        <label className='mt-1'>Ruolo intestatario</label>
                        <input className="form-control" name='ruolo' placeholder='direttore eventi.com' maxLength={40} onChange={handleInputChange} type='text' />

                        <label className='mt-1'>Email intestatario</label>
                        <input className="form-control" name='email' maxLength={40} onChange={handleInputChange} type='text' />

                        <label className='mt-1'>Sito web</label>
                        <input className="form-control" name='sito' maxLength={100} onChange={handleInputChange} type='text' />
                    </div>

                    <div className='mt-5'><b>Ordine di inserimento foto:</b><br />
                        1. Card img<br />
                        2. Foto alto in details<br />
                        3. Prima foto nel corpo del testo<br />
                        4. Seconda foto nel corpo del testo<br />
                        5. Terza foto nel corpo del testo<br />
                        6. Quarta foto nel corpo del testo<br />
                        7. Foto a destra (verticale) nel footer<br />
                        8. Foto a sinistra nel footer<br />
                    </div>
                    {/* <AddImg numero={[0, 1, 2, 3, 4, 5, 6, 7]} folder={'newsletter'} invioFoto={(e) => { setFormData({ ...formData, foto: e }) }} /> */}
                    <button type='submit' className='btn btn-primary'>INVIA</button>
                </form>
            }
        </div>
    </>
    )
}
export default EditNewsletter